<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import VConsole from "vconsole";

import { wxSDK } from "./plugins/wxSDK";
import { $config } from "./conf";
import Cookie from "js-cookie";
import store from "./store";
import moment from "moment";
import { GetQueryString } from "./plugins/url";
let clearNow = null;
let timestamp = Date.now();
export default {
  name: "App",
  mounted() {
    // const url = window.location.href;
    // if (url.indexOf("/uat/") > 0) {
    //   window.location.href = url.replace("/uat/", "");
    // }
    let now = GetQueryString("nowTime");
    if (now) {
      timestamp = now * 1000;
      store.state.nowTime = new Date(timestamp);
      clearNow = setInterval(() => {
        timestamp += 1000;
        store.state.nowTime = new Date(timestamp);
      }, 1000);
    } else {
      this.$api.getNow().then((res) => {
        timestamp = res * 1000;
        store.state.nowTime = new Date(timestamp);
        clearNow = setInterval(() => {
          timestamp += 1000;
          store.state.nowTime = new Date(timestamp);
        }, 1000);
      });
    }
    // const isTest = new URLSearchParams(window.location.search).get("isTest");
    // if (isTest) {
    //   let vConsole = new VConsole();
    // }
    const putType = new URLSearchParams(window.location.search).get("putType");
    if (putType) {
      Cookie.set("putType", putType);
    }

    const channel =
      new URLSearchParams(window.location.search).get("channel") || "";
    if (channel) {
      Cookie.set("channel", channel);
    }
    //兼容iphone active 无效解决办法
    document.body.addEventListener("touchstart", function () {});
    function setRem() {
      // 设计稿以1920px为宽度，而我把页面宽度设计为10rem的情况下
      let baseSize = 192; // 这个是设计稿中1rem的大小。
      // 移动端
      if (document.documentElement.clientWidth <= 992) {
        //  移动端 100px = 1rem
        baseSize = 100; // 这个是设计稿中1rem的大小。
        //   375为设计稿页面宽度，如为750，把375改为750
        const scale = document.documentElement.clientWidth / 375;
        // 设置页面根节点字体大小
        document.documentElement.style.fontSize =
          baseSize * Math.min(scale, 2) + "px";
      } else {
        // pc端
        baseSize = 192;
        const scale = document.documentElement.clientWidth / 1920;
        // 设置页面根节点字体大小
        document.documentElement.style.fontSize =
          baseSize * Math.min(scale, 2) + "px";
      }
    }
    if (this.$store.state.isMobile) {
      window.addEventListener("click", (e) => {
        let isHeader = document.getElementById("header").contains(e.target);
        if (!isHeader) {
          this.$bus.$emit("closeMenu");
        }
      });
    }
    let self = this;
    // 初始化
    setRem();
    // 窗口变化后，重置rem
    window.addEventListener(
      "resize",
      function (e) {
        self.$nextTick(() => {
          setRem();
        });
      },
      true
    );
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i)) {
      wxSDK.jsApiList = [
        "checkJsApi",
        "onMenuShareAppMessage",
        "onMenuShareTimeline",
        "updateAppMessageShareData",
        "updateTimelineShareData",
      ];
      wxSDK.init().then((wx) => {
        const share = {
          title: $config.shareConfig.title,
          desc: $config.shareConfig.desc,
          imgUrl: $config.shareConfig.imgUrl,
          link: window.location.href,
        };
        wx.onMenuShareAppMessage(share); // 微信好友
        wx.onMenuShareTimeline(share); // 朋友圈
      });
    }
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      wxSDK.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          this.$store.commit("updateMiniProgram", true);
        } else {
          this.$store.commit("updateMiniProgram", false);
        }
      });
    } else {
      this.$store.commit("updateMiniProgram", false);
    }
  },
  destroyed() {
    if (clearNow) {
      clearInterval(clearNow);
    }
  },
};
</script>

<style lang="scss">
@import "./assets/scss/style.scss";

html,
body {
  font-family: Microsoft YaHei-Light;
  font-weight: 400;
  height: 100%;
  //overflow: auto;
  -webkit-overflow-scrolling: touch;
  //iOS Safari浏览器上overflow: scroll元素无法滑动
  //background-color: #e3e9f5; //首页滑到最底部, 往上滑动时, 顶部会出现白色的导航栏框框(IE浏览器)
  #app {
    min-height: calc(100vh + 1px);
  }
}

@media (min-width: 992px) {
  * {
    scrollbar-width: thin;
  }

  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(127, 127, 127, 1);
  }
  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
  }
}

//@media (max-width: 992px) {
//  ::-webkit-scrollbar {
//    /*滚动条整体样式*/
//    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
//    height: 1px;
//    background: rgb(221, 108, 59);
//  }
//
//  ::-webkit-scrollbar-thumb {
//    border-radius: 10px;
//    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//    background: rgb(221, 108, 59);
//  }
//
//  ::-webkit-scrollbar-track {
//    /*滚动条里面轨道*/
//    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//    border-radius: 10px;
//    background: #ededed;
//  }
//}
</style>
